class PdpTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.pdpTabsList = this.querySelector('ul');
    this.allSectionsToScroll = document.querySelectorAll(
      '.shopify-section:has(.pdp-details), .shopify-section:has(.collapsible-content)'
    );

    const fragment = document.createDocumentFragment();

    this.allSectionsToScroll.forEach((section, index) => {
      const liElem = document.createElement('li');
      const pdpTabElem = document.createElement('pdp-tab');
      pdpTabElem.dataset.index = index;
      pdpTabElem.dataset.title =
        section.querySelector('[class*="__title"]').innerText;

      liElem.appendChild(pdpTabElem);

      fragment.appendChild(liElem);
    });

    this.pdpTabsList.appendChild(fragment);
  }
}

customElements.define('pdp-tabs', PdpTabs);
